const styleCss = {
  shopInfoWarp: `color: white;
                border-radius: 10px;
                padding: 0 10px;
                font-size: 22px;
                line-height:44px;
                background-color: rgba(0, 0, 0, 0.4);
                display:inline-block;
                height: 97px;
                text-align: center;
                width: 390px;`,
  shopInfoSpan: `
                font-size: 22px;
                margin-right:5px;`,
  shopInfoLine: `
                display:inline-block;
                height:15px;
                width:1px;
                background-color:white;
                opacity:0.3;
                margin:0 10px -3px;`,
}

export default styleCss



// WEBPACK FOOTER //
// ./src/views/contact/style.js